const __vite_glob_0_144 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 425 233.7\">\n  <title id=\"title-sort-asc\">Sort Ascending</title>\n  <path stroke=\"none\" d=\"M20.4 233.7L212.5 41.6l192.1 192.1z\" />\n  <path fill=\"none\" stroke-width=\"30\" stroke-miterlimit=\"10\" d=\"M414.4 223.1L212.5 21.2 10.6 223.1\" />\n</svg>\n";

export { __vite_glob_0_144 as default };
